module.exports = __webpack_public_path__ + "img/AFRICA_VEGETABLES.ee803992.png";